import { Pipe, PipeTransform } from '@angular/core';
import { FormStatus } from '../models/form.model';
import { BadgeColor } from '../../../shared/components/ui/badge/badge.component';

@Pipe({ name: 'formStatus', standalone: true, pure: true })
export class FormStatusPipe implements PipeTransform {
  transform(status: FormStatus, format: 'color'): BadgeColor;
  transform(status: FormStatus, format?: 'label'): string;

  transform(status: FormStatus, format: 'label' | 'color' = 'label'): string | BadgeColor {
    if (format === 'color') {
      const colorMap: Record<FormStatus, BadgeColor> = {
        DRAFT: 'warning',
        PUBLISHED: 'success',
        ARCHIVED: 'info',
        PAUSED: 'error',
      };
      return colorMap[status] ?? 'info';
    }

    const labelMap: Record<FormStatus, string> = {
      DRAFT: 'Borrador',
      PUBLISHED: 'Publicado',
      ARCHIVED: 'Archivado',
      PAUSED: 'Pausado',
    };
    return labelMap[status] ?? 'Desconocido';
  }
}
